import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../LanguageContext";

function PrivacyEn() {
  return (
    <>
      <p>Perform Fitness does not collect, store, or transmit any personal data to external servers or third parties.</p>

      <h2>Local Storage Only</h2>
      <p>All data you enter in the app – including your name, age, weight, height, and training records – is stored exclusively on your device. Your data never leaves your device.</p>

      <h2>No Third-Party Sharing</h2>
      <p>No data is shared with, sold to, or used by any third parties.</p>

      <h2>No Analytics or Tracking</h2>
      <p>The app does not use any tracking, analytics tools, or advertising services.</p>

      <h2>Data Deletion</h2>
      <p>You can delete all stored data at any time from within the app settings.</p>

      <h2>Contact</h2>
      <p>For privacy-related questions, contact: <a href="mailto:developer@steuernagel.net">developer@steuernagel.net</a></p>
    </>
  );
}

function PrivacyDe() {
  return (
    <>
      <p>Perform Fitness erhebt, speichert oder überträgt keine personenbezogenen Daten an externe Server oder Dritte.</p>

      <h2>Lokale Datenspeicherung</h2>
      <p>Alle Daten, die Du in der App eingibst – darunter Dein Name, Alter, Gewicht, Körpergröße sowie Deine Trainingsaufzeichnungen – werden ausschließlich lokal auf Deinem Gerät gespeichert. Die Daten verlassen Dein Gerät zu keinem Zeitpunkt.</p>

      <h2>Keine Weitergabe an Dritte</h2>
      <p>Es werden keine Daten an Dritte weitergegeben, verkauft oder für Werbezwecke genutzt.</p>

      <h2>Keine Analyse oder Tracking</h2>
      <p>Die App verwendet kein Tracking, keine Analyse-Tools und keine Werbedienste.</p>

      <h2>Datenlöschung</h2>
      <p>Du kannst alle gespeicherten Daten jederzeit in den App-Einstellungen löschen.</p>

      <h2>Kontakt</h2>
      <p>Bei Fragen zum Datenschutz wende Dich an: <a href="mailto:developer@steuernagel.net">developer@steuernagel.net</a></p>
    </>
  );
}

function PrivacyPerformFitness() {
  const { lang } = useLang();
  const isDE = lang === "de";

  return (
    <div className="dev-page">
      <div className="page-section-header">
        <span className="section-label">
          <Link to="/perform-fitness" className="back-link">← Perform Fitness</Link>
        </span>
        <div className="subhead">{isDE ? "Datenschutzerklärung" : "Privacy Policy"}</div>
        <p className="section-intro-inner privacy-meta">
          Perform Fitness · {isDE ? "Stand: März 2026" : "Last updated: March 2026"}
        </p>
      </div>

      <div className="privacy-content">
        {isDE ? <PrivacyDe /> : <PrivacyEn />}
        <p className="privacy-footer">© Kai Steuernagel — Perform Fitness</p>
      </div>
    </div>
  );
}

export default PrivacyPerformFitness;
